export default __webpack_public_path__ + "static/media/setSide.918ce987.svg";